/* eslint-disable */ import { attributeSelectionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const sunlifeShortsComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'pattern', true).withAlias('SunlifeShorts').attach(memoEval((self)=>[
            self.type
        ], (type)=>({
            options: [
                {
                    value: 'SwimShorts',
                    label: 'Swim Shorts'
                },
                {
                    value: 'BoardShorts',
                    label: 'Board Shorts'
                }
            ],
            value: type
        })), ()=>{
        return {};
    })
];

//# sourceMappingURL=sunlife-shorts.js.map